/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchSelectedMediaOutletsResponse
 */
export interface SearchSelectedMediaOutletsResponse {
    /**
     * ヒットしたメディアのIDリスト
     * @type {Array<number>}
     * @memberof SearchSelectedMediaOutletsResponse
     */
    hitMediaOutletIds: Array<number>;
}

export function SearchSelectedMediaOutletsResponseFromJSON(json: any): SearchSelectedMediaOutletsResponse {
    return SearchSelectedMediaOutletsResponseFromJSONTyped(json, false);
}

export function SearchSelectedMediaOutletsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSelectedMediaOutletsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hitMediaOutletIds': json['hit_media_outlet_ids'],
    };
}

export function SearchSelectedMediaOutletsResponseToJSON(value?: SearchSelectedMediaOutletsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hit_media_outlet_ids': value.hitMediaOutletIds,
    };
}

